import { Component, Input, OnInit } from '@angular/core'
import { LocaleCode } from 'src/app/interfaces/locale'
import { KakaoService } from 'src/app/services/kakao/kakao.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'app-login-install-choice-modal',
  templateUrl: './login-install-choice-modal.component.html',
  styleUrls: ['./login-install-choice-modal.component.scss'],
})
export class LoginInstallChoiceModalComponent implements OnInit {
  constructor(
    private kakaoService: KakaoService,
    private modalService: ModalService,
    private localeService: LocaleService
  ) {}

  @Input() title = ''
  @Input() description = ''
  @Input() alertText = ''
  @Input() logOnClickLogin: (() => void) | undefined
  @Input() logOnClickInstall: (() => void) | undefined
  locale$ = this.localeService.locale$
  eLocaleCode = LocaleCode

  ngOnInit() {}

  onClickClose(): void {
    this.modalService.dismiss()
  }

  onClickLogin(): void {
    this.logOnClickLogin?.()
    this.kakaoService.login(location.pathname)
  }

  onClickInstall(): void {
    this.logOnClickInstall?.()
  }
}
